import { render, staticRenderFns } from "./BaseFrontOfficeCard.vue?vue&type=template&id=d539738c&scoped=true"
import script from "./BaseFrontOfficeCard.vue?vue&type=script&lang=js"
export * from "./BaseFrontOfficeCard.vue?vue&type=script&lang=js"
import style0 from "./BaseFrontOfficeCard.vue?vue&type=style&index=0&id=d539738c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d539738c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {VCard,VCardActions,VCardText,VCardTitle,VDivider})
